var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('get-started',{attrs:{"label":_vm.companyName,"logoUrl":_vm.logoURL,"selectedLanguage":_vm.selectedLanguage,"languages":_vm.languages},on:{"startClassic":_vm.startClassic,"changeLanguage":_vm.changeLanguage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }